import React, { useContext } from "react";
import { yellowBtn, buttonUnv, redBtn } from "../../shared/components/Button";
import { toast } from "react-toastify";
import { AuthContext } from "../../shared/context/auth-context";

const AnimeInfo = ({ animeInfo, handleView, view, openAuth }) => {
  const auth = useContext(AuthContext);
  const trimText = (text) => {
    const maxLength = 400;
    let trimmedText;
    let finalTrim;
    if (text.length >= 400 && text) {
      trimmedText = text.substring(0, maxLength);
      finalTrim = trimmedText.substring(
        0,
        Math.min(trimmedText.length, trimmedText.lastIndexOf(" "))
      );
      return finalTrim;
    } else {
      return text;
    }
  };

  const handleAddToWatched = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/watched/addWatched`,
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + auth.token,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            mal_id: animeInfo.mal_id.toString(),
            title: animeInfo.title,
            imageUrl: animeInfo.images.webp.large_image_url,
            synopsis: animeInfo.synopsis,
            score: animeInfo.score,
          }),
        }
      );

      if (response.status === 406) {
        toast.warn("Anime Already Added", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else if (!response.ok) {
        toast.error("Something Went Wrong! Try again", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }

      if (response.ok) {
        toast.success(`${animeInfo.title} Add To Watched list `, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    } catch (error) {}
  };

  const handleAddToWatch = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/watch/addWatch`,
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + auth.token,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            mal_id: animeInfo.mal_id.toString(),
            title: animeInfo.title,
            imageUrl: animeInfo.images.webp.large_image_url,
            synopsis: animeInfo.synopsis,
            score: animeInfo.score,
          }),
        }
      );

      if (response.status === 406) {
        toast.warn("Anime Already Added", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      } else if (!response.ok) {
        toast.error("Something Went Wrong! Try again", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
      if (response.ok) {
        toast.success(`${animeInfo.title} Add To Watch list `, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    } catch (error) {}
  };

  return (
    <div className="px-sm flex flex-col justify-center items-center md:items-start w-auto  ">
      <h1 className="font-display text-xxl font-medium text-center md:text-left mb-sm">
        {animeInfo.title_english || animeInfo.title}
      </h1>
      <h3 className="font-display text-xm text-center lg:text-left mb-sm">
        Synopsis
      </h3>
      <p className="font-body text-s leading-body ">
        {animeInfo.synopsis
          ? !view
            ? `${trimText(animeInfo.synopsis)}...`
            : animeInfo.synopsis
          : ""}
      </p>
      {!view ? (
        <button
          onClick={() => handleView()}
          className="my-sm  w-xl text-left underline underline-white underline-offset-2 font-body text-s mb-sm"
        >
          See More
        </button>
      ) : (
        <button
          onClick={() => handleView()}
          className="my-sm w-xl text-left underline underline-white underline-offset-2 font-body text-s mb-sm "
        >
          See Less
        </button>
      )}
      {!auth.isLoggedIn ? (
        <button
          onClick={() => openAuth()}
          className={`${buttonUnv} ${redBtn} w-[170px]`}
        >
          Login
        </button>
      ) : (
        <div className="flex gap-sm flex-wrap mt-sm">
          <button
            onClick={handleAddToWatch}
            title="Add to Must Watch List"
            className={`${buttonUnv} ${yellowBtn} text-white flex justify-evenly w-{180px}  flex-nowrap items-center w-[170px]`}
          >
            To Watch List
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="ml-xsm h-md w-md "
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
              />
            </svg>
          </button>
          <button
            onClick={handleAddToWatched}
            title="Add to Anime List "
            className={`${buttonUnv} ${redBtn} text-white flex justify-between w-{180px} flex-nowrap items-center w-[170px]`}
          >
            Watched List
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="ml-xsm h-md w-md "
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </button>
        </div>
      )}
    </div>
  );
};

export default AnimeInfo;
